module.exports = __webpack_public_path__ + "img/hero-md.503bedf2.webp";